import { CircularProgress, DialogTitle, Stack } from "@mui/material";
import {
  CloseIconWrapper,
  FontGrayNormal,
  ModalTitle,
  StyledContainedButton,
  StyledDialog,
  StyledOutlinedButton,
} from "./style";
import { CloseIcon } from "../../assets/Icons";
import { DeleteConfirmationModalProps } from "../../utils/propTypes";
import { useTheme } from "styled-components";

const DeleteConfirmationModal = ({
  isOpen,
  handleClose,
  handleDelete,
  modalTitle,
  modalDescription,
  loading = false,
  btnLabel = "Delete",
}: DeleteConfirmationModalProps) => {
  const theme = useTheme();

  return (
    <StyledDialog onClose={handleClose} open={isOpen} maxWidth="md" fullWidth>
      <Stack
        sx={{
          padding: "1.25rem 1.875rem 1.25rem 1.25rem",
          gap: "1.875rem",
        }}
      >
        <DialogTitle>
          <Stack direction="row" gap="0.75rem" alignItems="start">
            <Stack>
              <ModalTitle>{modalTitle}</ModalTitle>
              <FontGrayNormal>{modalDescription}</FontGrayNormal>
            </Stack>
          </Stack>
          <CloseIconWrapper aria-label="close" onClick={handleClose}>
            <CloseIcon />
          </CloseIconWrapper>
        </DialogTitle>
        <Stack
          direction="row"
          alignItems="center"
          gap="0.625rem"
          sx={{ marginLeft: "auto" }}
        >
          <StyledOutlinedButton
            variant="outlined"
            size="small"
            padding="0.313rem 1.5rem"
            onClick={handleClose}
          >
            Cancel
          </StyledOutlinedButton>
          <StyledContainedButton
            variant="contained"
            size="small"
            background={theme.colors.red200}
            sx={{
              padding: "0.313rem 1.5rem",
            }}
            onClick={handleDelete}
          >
            {loading ? (
              <CircularProgress
                size={20}
                sx={{ color: theme.colors.black2, marginRight: "5px" }}
              />
            ) : null}
            {btnLabel}
          </StyledContainedButton>
        </Stack>
      </Stack>
    </StyledDialog>
  );
};

export default DeleteConfirmationModal;
